import { Component } from 'react';
import PubSub from 'pubsub-js';
import TokenStore from '../lib/token_store.js';

class SubscribedComponent extends Component {
  state = { permissions: [], subscriptionExpirations: {}, claims: {} }

  componentWillMount(){
    this.token = PubSub.subscribe('NEW_TOKEN_STORED', this.newToken.bind(this));
  }

  componentDidMount(){
    TokenStore.get()
      .then((token) => this.newToken('initial', token))
  }

  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
  }

  hasPermission(permission){
    const { permissions } = this.state
    return permissions.includes(permission)
  }

  emotyPermissions(){
    const { permissions } = this.state
    return permissions.length === 0
  }

  getClaim(path){
    return path.reduce((nestedObj, pathPart) =>
      (nestedObj && nestedObj[pathPart]) ? nestedObj[pathPart] : null, this.state.claims)
  }


  newToken(_msg, token){
    if (token) {
      const claims = JSON.parse(atob(token.split('.')[1]));
      const { permissions, subscription_expirations } = claims;
      this.setState(() => ({
        permissions: permissions.split(','),
        subscriptionExpirations: subscription_expirations,
        claims: claims
      }))
    }
  }
}

export default SubscribedComponent;



// WEBPACK FOOTER //
// ./src/components/subscribed_component.js